import {animate, state, style, transition, trigger} from '@angular/animations';

export const ANIMATION_TIME = 300;
export const ANIMATION_FADE_TIME = 1000;

export const PAGE_TRANSITION_ANIMATION = [
  trigger('openClose', [
    state('open', style({opacity: 1})),
    transition('void => open', [style({opacity: 0}), animate(ANIMATION_TIME)]),
    state('close', style({opacity: 0})),
    transition('open => close', [style({opacity: 1}), animate(ANIMATION_TIME)]),
  ]),
];
